import { z } from 'zod';
import type { WorkspaceDto } from './workspaces.js';

export interface MeDto {
  user: { id: string; name: string; email: string; isInstanceAdmin: boolean; image: string | null; updatedAt: string };
  workspaces: WorkspaceDto[];
  /**
   * Abnahme 0.63: nur für Linkgäste – Zustand des Zugangs über den Projektlink, damit offene Ansichten verständlich
   * sagen können, warum nichts mehr erreichbar ist (ruht: Teilen per Link aus, Notfallsperre, abgelaufen)
   */
  linkAccess?: { projectId: string; project: string; state: 'active' | 'paused' | 'locked' | 'expired' } | null;
  /** 0.151 (ADR 0153): persönliche Darstellung (fehlt = nie gewählt → System/Normal/Dezent) */
  display?: DisplayPrefs | null;
}

/* ---------- 0.151 (ADR 0153): persönliche Darstellung ---------- */
export const DISPLAY_THEMES = ['system', 'light', 'dark'] as const;
export const DISPLAY_DENSITIES = ['normal', 'compact'] as const;
export const DISPLAY_MOTIONS = ['subtle', 'reduced'] as const;
export interface DisplayPrefs {
  theme: (typeof DISPLAY_THEMES)[number];
  density: (typeof DISPLAY_DENSITIES)[number];
  motion: (typeof DISPLAY_MOTIONS)[number];
}
export const DEFAULT_DISPLAY_PREFS: DisplayPrefs = { theme: 'system', density: 'normal', motion: 'subtle' };
export const displayInput = z.object({ theme: z.enum(DISPLAY_THEMES), density: z.enum(DISPLAY_DENSITIES), motion: z.enum(DISPLAY_MOTIONS) }).strict();

/** Öffentlich vor der Anmeldung */
export interface PublicConfigDto {
  instanceName: string;
  logo?: string | null;
  /** 0.151: Logo für dunklen Hintergrund und eigenes Favicon der Instanz */
  logoDark?: string | null;
  favicon?: string | null;
  /** 0.154 (ADR 0156): wirksame Upload-Grenze (Ablage, Anhänge, Fassungen) für frühe Rückmeldung */
  maxUploadBytes?: number;
  color?: string | null;
  version: string;
  needsSetup: boolean;
  mailEnabled: boolean;
  passkeys: boolean;
}
